module.exports = __webpack_public_path__ + "img/star.6422ac8d.png";